import { render, staticRenderFns } from "./LegalEntityDocumentItem.vue?vue&type=template&id=0868e7d0&scoped=true"
import script from "./LegalEntityDocumentItem.vue?vue&type=script&lang=js"
export * from "./LegalEntityDocumentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0868e7d0",
  null
  
)

export default component.exports